'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _types = require('./types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = function defaultState() {
    return {
        mainMenuOpened: false,
        sitemapOpened: false
    };
};

var mainReducers = function mainReducers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState();
    var action = arguments[1];

    if (action.type === _types.UI_TOGGLE_SITEMAP) {
        return (0, _extends3.default)({}, state, {
            sitemapOpened: !state.sitemapOpened
        });
    }

    if (action.type === _types.UI_TOGGLE_MAIN_MENU) {
        return (0, _extends3.default)({}, state, {
            mainMenuOpened: !state.mainMenuOpened
        });
    }

    return state;
};

exports.default = mainReducers;
//# sourceMappingURL=main-reducers.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/redux/core-navigation-ui/main-reducers.js
 ** module id = 623
 ** module chunks = 1
 **/